module.exports = __webpack_public_path__ + "img/1612.fa278fd6.gif";